export default __webpack_public_path__ + "static/media/mobile_app_heading.6647ec9e.png";